export const aboutData = {
  id: 1,
  title: "ABOUT US",
  content:
    "<p>At Meridian Data Labs we leverage latest technology trends in Data Science and Machine Learning to provide our clients with real-time decision support systems.</p><p>Our team works together to implement end-to-end, comprehensive data strategies that will transform your business by using knowledge as a key factor to maximize your ROI.</p>",
  image: require("../images/logo_big.png")
}
